import { render, staticRenderFns } from "./refund-tips.vue?vue&type=template&id=7742dd6d&scoped=true&"
import script from "./refund-tips.vue?vue&type=script&lang=js&"
export * from "./refund-tips.vue?vue&type=script&lang=js&"
import style0 from "./refund-tips.vue?vue&type=style&index=0&id=7742dd6d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7742dd6d",
  null
  
)

export default component.exports